export const baseUrl = {
  base: ''
}